<div [class.d-none]="$hide" class="response-fixed">
  <div class="response-menu d-flex justify-content-between">
    <div class="response-type">
      <span>
        @if (responseType === 'reponse') {
          <span>Répondre</span>
        }
        @if (responseType === 'relance') {
          <span>Répondre et relancer</span>
        }
        @if (responseType === 'clore') {
          <span>Répondre et clore</span>
        }
        <fa-icon icon="caret-down"></fa-icon>
      </span>
      <select [(ngModel)]="responseType">
        <option value="reponse">Répondre</option>
        <option value="relance">Répondre et relancer</option>
        <option value="clore">Répondre et clore</option>
      </select>
    </div>
    <div class="d-flex menu-actions">
      <fa-icon size="lg" icon="times" (click)="setHide()"></fa-icon>
      <div class="paperclip">
        <app-upload-file [(sendedFiles)]="sendedFiles" [mobile]="true"></app-upload-file>
      </div>
      <fa-icon size="lg" icon="paper-plane" (click)="doSend()"></fa-icon>
    </div>
  </div>
  <div class="overflow-auto">
    <textarea (input)="autogrow()" [(ngModel)]="body" #textarea placeholder="Saisissez votre réponse"></textarea>
    @for (f of sendedFiles; track f) {
      <div class="p-2">
        <div class="pj-container">
          <div class="pe-2" style="min-width: 0; display:inline-flex;flex-wrap:nowrap;">
            @if (f.filename.length < 14) {
              <div>
                {{ f.filename }}
              </div>
            } @else {
              <div
                style="flex: 0 1 content;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;">{{ f.filename.substr(0, f.filename.length - 13) }}
              </div>
              <div style="flex: 1 0 content;white-space:nowrap;"> {{ f.filename.substr(f.filename.length - 13) }}</div>
            }
          </div>
          @if (f.toolarge) {
            <div class="text text-danger">Fichier trop volumineux (10 Mo max)</div>
          }
          <fa-icon icon="times" (click)="deleteFile(f)"></fa-icon>
        </div>
        @if (!f.uploaded) {
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
          [style.width.%]="f.progress"></div>
        }
      </div>
    }
  </div>
</div>
